module.exports = __webpack_public_path__ + "static/media/tessin.d12da8a5.png";